import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
import EmptyPageView from '@/views/common/EmptyPageView'
import HomePageView from '@/views/HomePage'
import Login from '@/views/Login'
import db from 'utils/localstorage'
import { cloneDefaultRouter, normalizeRouters } from './asyncRouter'

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

const constRouter = [
  {
    path: '/login',
    name: '登录页',
    component: Login
  }
]

const router = new Router({
  routes: constRouter
})

const whiteList = ['/login']
let asyncRouter

router.beforeEach((to, from, next) => {
  const token = db.get('USER_TOKEN')
  const user = db.get('USER')

  if (whiteList.indexOf(to.path) !== -1) {
    if (token && token.length && user) {
      next('/home')
      return
    }
    next()
    return
  }

  if (token && token.length && user) {
    if (!asyncRouter) {
      asyncRouter = db.get('USER_ROUTER')
      if (!asyncRouter || !asyncRouter.length) {
        asyncRouter = cloneDefaultRouter()
      }
      go(to, next)
    } else {
      next()
    }
  } else {
    next('/login')
  }
})

function go (to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter)
  router.addRoutes(asyncRouter)
  next({ ...to, replace: true })
}

function filterAsyncRouter (routes) {
  return (routes || []).filter((route) => {
    const component = route.component
    if (component) {
      switch (route.component) {
        case 'MenuView':
          route.component = MenuView
          break
        case 'PageView':
          route.component = PageView
          break
        case 'EmptyPageView':
          route.component = EmptyPageView
          break
        case 'HomePageView':
          route.component = HomePageView
          break
        default:
          route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
    return false
  })
}

const viewModules = import.meta.glob('../views/**/*.vue')

function view (path) {
  return function (resolve) {
    const importer = viewModules[`../views/${path}.vue`]
    if (!importer) {
      resolve(EmptyPageView)
      return
    }
    importer().then(mod => {
      resolve(mod)
    }).catch(() => {
      resolve(EmptyPageView)
    })
  }
}

export function resetAsyncRouter () {
  asyncRouter = null
}

export { normalizeRouters }

export default router
